import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Card from 'components/Card';
import { benefitsCardsData } from 'sections/Resources/FreightTemplates/data';
import { BenefitsCard } from 'sections/Resources/FreightTemplates/types';
import styles from 'sections/Resources/FreightTemplates/components/SectionBenefits/SectionBenefits.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  const cards = benefitsCardsData.map((card: BenefitsCard) => {
    return (
      <Card className={cn('card')} key={card.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__heading-box')}>
            <img
              className={cn('card__icon')}
              src={`/images/pages/Resources/FreightTemplates/${card.iconName}`}
              alt='file'
            />
            <h4 className={cn('card__heading')}>
              {card.heading}
            </h4>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p className={cn('card__paragraph')}>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('benefits')}>
      <div className={cn('container')}>

        <h2 className={cn('benefits__heading')}>
          <span>A Streamlined List of Templates</span>{' '} 
          <span>Provided by DP World</span>
        </h2>

        <div className={cn('benefits__cards')}>
          {cards}
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;